import * as React from 'react';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import BlockIcon from '@mui/icons-material/Block';
import jwtInterceptor from '../service/jwtInterceptor';
import moment from 'moment/moment';
import {useApplication} from '../hooks/UseApplication';
import {API_URL} from '@utils/constants';
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import {Chip} from "@mui/material";

function TableRowUser({row, keyIndex, userType, onEdit}) {
    const {user} = useApplication();

    const deleteUser = (row) => {
        if (row) {
            if (row._source.id != user.id) {
                jwtInterceptor.delete(`${API_URL}/user?id=${row._source.id}`).then(res => {
                    window.location.reload(false);
                });
            }
        }
    }

    const handleEdit = (e) => {
        e.stopPropagation();
        if (row && row._source.id !== user.id) {
            onEdit(row);
        }
    };

    const shouldDisplayRow = () => {
        if (!row || !row._source || !row.userDetails) {
            return false;
        }
        if (userType === "admin") {
            return row.userDetails.typeUser === "agence_admin";
        }
        return row.userDetails.typeUser !== "agence_admin";
    };

    if (!shouldDisplayRow()) {
        return null;
    }

    return (
        <tr sx={{"& > *": {borderBottom: "unset"}}} key={keyIndex}
            style={keyIndex % 2 === 0 ? {backgroundColor: "", width: "100%", cursor: "pointer"} : {
                backgroundColor: "",
                width: "100%",
                cursor: "pointer"
            }}>
            <td className="px-2 w-1/6 align-middle" align="left">
                {row._source.username || ''}
            </td>
            <td className="px-2 w-1/6 align-middle" align="left">
                {row._source.firstname || ''}
            </td>
            <td className="px-2 w-1/6 align-middle" align="left">
                {userType === "admin" && row.userDetails.typeUser === "agence_admin" ?
                    (row.userDetails.agence || '') : (
                        <Chip sx={{background: "#3F50B6", color: "#fff"}}
                              label={row.userDetails.typeUser || 'Non défini'}/>)
                }
            </td>
            <td className="px-2 w-1/6 align-middle" align="left">
                {row._source.email || ''}
            </td>
            <td className="px-2 w-1/6 align-middle" align="left">
                {row._source.createdAt ? moment(row._source.createdAt).format("DD-MM-YYYY") : ''}
            </td>
            <td className="px-2 w-1/6 align-middle" align="left">
                {row._source.updatedAt ? moment(row._source.updatedAt).format("DD-MM-YYYY") : ''}
            </td>
            {userType === "admin" ? (<></>) : (
                <td className="px-2 w-[7.66%] d-flex">
                    <IconButton aria-label="expand row" size="small" onClick={handleEdit}>
                        {user.id === row._source.id ? <BlockIcon/> : <ModeEditIcon/>}
                    </IconButton>
                    <IconButton aria-label="expand row" size="small" onClick={() => deleteUser(row)}>
                        {user.id === row._source.id ? <BlockIcon/> : <DeleteIcon/>}
                    </IconButton>
                </td>
            )}
        </tr>
    );
}

export default TableRowUser;
